var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{staticClass:"loader"},[_c('span',{staticClass:"loader__spinner"}),_vm._v(" "),_c('p',{staticClass:"loader__text"},[_vm._v(_vm._s(_vm.text))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }